"use strict";

angular.module('rmItemPlanner', []);

require('./controller');
require('./directives');
require('./services');
require('./routes');
